import { Component, Input, OnInit } from '@angular/core';
import { TickerTableDataSource } from '../main-table-content-v2/TickerTableDataSource';

@Component({
  selector: 'app-tri-value-checkbox',
  templateUrl: './tri-value-checkbox.component.html',
  styleUrls: ['./tri-value-checkbox.component.scss'],
  standalone: false,
})
export class TriValueCheckboxComponent implements OnInit {
  @Input()
  public dataSource: TickerTableDataSource;

  private pageData: any[];

  private checked: number;

  constructor() {}

  MarkedStatus = MarkedStatus;

  value: MarkedStatus = MarkedStatus.NONE;

  checkboxValue: boolean = false;

  ngOnInit(): void {
    this.dataSource.pageDataSubject.subscribe((pageData) => {
      this.pageData = pageData;
      this.checked = pageData.filter((d) => d.checked).length;
      if (this.checked === 0) {
        this.value = MarkedStatus.NONE;
        this.checkboxValue = false;
      } else if (this.checked != this.pageData.length) {
        this.value = MarkedStatus.SOME;
        this.checkboxValue = false;
      } else {
        this.value = MarkedStatus.ALL;
        this.checkboxValue = true;
      }
    });
  }

  onCheckboxClick($event) {
    if ($event) {
      this.dataSource.checkAllOnPage();
    } else {
      this.dataSource.uncheckAllOnPage();
    }
  }
}

export enum MarkedStatus {
  NONE = 'NONE',
  ALL = 'ALL',
  SOME = 'SOME',
}
